import { Container, Wrapper } from './styles';

const NovosAplicativos: React.FC = () => {
  return (
    <Container>
      <Wrapper>
        <img
          src="/aplicativos/novos-aplicativos.svg"
          alt="Imagem de novos aplicativos"
        />
        <p>
          Além dos aplicativos acima, também desenvolvemos web apps 100%
          personalizados para necessidades mais específicas.
        </p>
      </Wrapper>
    </Container>
  );
};

export default NovosAplicativos;
